import { useMediaQuery } from './use-media-query.hook';
import { BREAKPOINTS } from '../constants/breakpoints';

export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${BREAKPOINTS.mobile.css})`);
